import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "HighlightedFeaturesIntroductionContentWrapper" }
const _hoisted_2 = {
  ref: "modalContent",
  class: "HighlightedFeaturesIntroductionContent"
}
const _hoisted_3 = { class: "HighlightedFeaturesIntroductionModalTextWrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("img", {
        alt: "Woman behind laptop with hand raised representing questions that could arise about features ERT",
        src: "https://monet-prtl-co.imgix.net/Endor/ERT/highlighted-features-introduction.svg",
        class: "HighlightedFeaturesIntroductionImage"
      }, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "HighlightedFeaturesIntroductionModalTitle" }, " Essential Tips and Features ", -1 /* CACHED */)),
        _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "HighlightedFeaturesIntroductionModalSubtitle" }, " Unlock the power of the Enrolment Review Tool ", -1 /* CACHED */)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "HighlightedFeaturesIntroductionModalText" }, " Explore handy tips and features designed to streamline your use of our Enrolment Review Tool and enhance your review process. ", -1 /* CACHED */)),
        _createElementVNode("button", {
          class: "NavigatorButton HighlightedFeaturesIntroductionModalButton",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToFirstHighlightedFeature && _ctx.navigateToFirstHighlightedFeature(...args)))
        }, " Start now ")
      ])
    ], 512 /* NEED_PATCH */)
  ]))
}